import { Flex } from "@chakra-ui/react";
import { DotLoader } from "../DotLoader";

interface PropTypes {
  overlayColor?: string;
  overlayStyle?: React.CSSProperties;
  /** Distance from the top of the viewport.
   *  - **number** — interpreted as a Chakra spacing token (e.g. `24` → 96 px).
   *  - **string** — used as a raw CSS value (e.g. `"var(--euka-header-height, 96px)"`).
   */
  top?: number | string;
}

const PageLoader = ({ overlayColor, overlayStyle, top = 0 }: PropTypes) => {
  // When `top` is a string (e.g. a CSS variable) it is already a valid CSS
  // length and can be used directly in calc().  When it is a number we
  // convert it via the Chakra 4px-per-unit scale so existing callers keep
  // working unchanged.
  const topValue = typeof top === "string" ? top : top;
  const heightCalc =
    typeof top === "string"
      ? `calc(100vh - ${top})`
      : `calc(100vh - ${top * 4}px)`;

  return (
    <Flex
      data-bark-component="PageLoader"
      position="fixed"
      top={topValue}
      left={0}
      w="100vw"
      h={heightCalc}
      zIndex={9999}
      bg={overlayColor || "transparent"}
      align="center"
      justify="center"
      style={overlayStyle}
      data-testid="page-loader"
    >
      <DotLoader size="lg" />
    </Flex>
  );
};

export default PageLoader;
